import React from 'react';
import { SKELETON_PROPS } from '@/lib/constants/skeleton';

/**
 * Placeholder bars matching a dark-background `<Price>` row: the
 * sale/crossed/savings run on the left, the "Price details" link on the right.
 */
export function PriceSkeleton({ showPriceDetails }) {
  return (
    <span
      className="flex min-h-7.5 items-center justify-between"
      {...SKELETON_PROPS}
    >
      <span className="bg-parlor-green-80 h-5 w-52 max-w-full rounded-sm" />
      {showPriceDetails && (
        <span className="bg-parlor-green-80 ml-3 h-4 w-20 shrink-0 rounded-sm" />
      )}
    </span>
  );
}

/**
 * Single-line placeholder bar matching the Affirm financing message.
 * (It's 1px taller than just the text because of their logo that pops in.)
 */
export function FinanceMsgSkeleton() {
  return (
    <span className="flex min-h-5.25 items-center" {...SKELETON_PROPS}>
      <span className="bg-parlor-green-80 h-4 w-full max-w-64 rounded-sm" />
    </span>
  );
}
